export enum BankIdStatusEnum {
    waiting = 'waiting',
    checking = 'checking',
    verified = 'verified',
}
